
import {Component, Prop, Vue} from "vue-property-decorator";
import PaymentArticlesAddForm from "@/form/finance/payment_articles/PaymentArticlesAddForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup}
})
export default class PaymentArticlesAddComponent extends Vue {
  @Prop() readonly form!: PaymentArticlesAddForm;
}
